export default __webpack_public_path__ + "static/media/pictoboard.5e6c0269.png";